import "./jewelry.css"
import DataVisualization from "../../components/data-visualization";
import { useEffect, useState } from "react";
import { useUser } from "@/hooks/useUser";
import { LoadingScreen } from "@/features/loading-screen";
import { getAllData, getData, getFilterData, getRole, getStats, onCreate, onDelete, onExportData, onUpdate, type SortOption, type StatsType, type TagType } from "@/features/data/view-model/viewModel";
import { columns, columnsExport, filters, sortOptions, type JewelryType, type JewelryInsert, type JewelryUpdate } from "@/features/data/pages/jewelry/jewelry-model"


function Jewelry<T extends Record<string, any>> () {

  const {id: user_id} = useUser();

  const table = "jewelry"
  const title = "Bijoux";

  const [jewelry, setJewelry] = useState([] as JewelryType[]);
  const [filterData, setFilterData] = useState({
    brand: [],
    type: [],
    at_bank: [],
    at_monaco: [],
  });
  const [count, setCount] = useState(0);
  const [stats, setStats] = useState({} as StatsType);
  const [currentRole, setCurrentRole] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [exportData, setExportData] = useState([] as JewelryType[]);

  const onExport = async (columns: string[], name?: string, sort?: SortOption, tags?: TagType[], ) => { 
       onExportData(columnsExport, columns, "jewelry", sort, tags, name);
   };

  const getRoleJewery = async () => {
    const { data } = await getRole();
    setCurrentRole(data);
  };


    const getStatsJewelry = async () => {
        const { data, error } = await getStats("jewelry_dashboard");
        setStats(data)
    }

    const getAllJewelry = async () => {
      const { data } = await getAllData(table);
      setExportData(data);
  }
    
    useEffect(() => {
        getAllJewelry()
        getRoleJewery();
        getStatsJewelry();
        getFilterJewelry();
        setIsLoading(false);
    }, [])
    

  const getJewelry = async (
           page: number,
           sortOption?: SortOption,
           tags?: TagType[]
         ) => {
    const { data, count } = await getData(page, table, sortOption, tags);
          
    setJewelry(data ?? []);
    setCount(count ?? 0);
  };

  const getFilterJewelry = async () => {
    const [brands, types, at_bank, at_monaco] = await Promise.all([
      getFilterData("jewelry", "brand"),
      getFilterData("jewelry", "type"),
      getFilterData("jewelry", "at_bank"),
      getFilterData("jewelry", "at_monaco"),
    ]);
  
    setFilterData({
      brand: brands,
      type: types,
      at_bank: at_bank,
      at_monaco: at_monaco
    });
  };

  const onDeleteJewelry = async (id: string) => {
      onDelete(id, table);
  };

  const onCreateJewelry = async (values: JewelryInsert) => {
        onCreate(user_id, values, table);
  };

  const onUpdateJewelry = async (values: JewelryUpdate, id: string) => {
        onUpdate(user_id, values, table, id);
  };
    
  return <>
  {isLoading ? <LoadingScreen/> : 
      <DataVisualization<JewelryType> 
            columns={columns} 
            columnsExport={columnsExport}
            count={count}
            data={jewelry} 
            filters={filters}
            filterData={filterData}
            title={title}
            role={currentRole}
            stats={stats}
            table={table} 
            sortOptions={sortOptions}
            getData={getJewelry} 
            onCreate={onCreateJewelry}
            onDelete={onDeleteJewelry} 
            onUpdate={onUpdateJewelry} 
            onExportData={onExport}
      />         
  }</>
}

export default Jewelry;